module.exports = __webpack_public_path__ + "static/media/inclusion_ambulance.0b9c9d7b.svg";